import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { showSuccessToast } from '../../app/utils/tostify';
import {
	deleteNewImageList,
	getImagesMatch,
	getNewImagesList,
	imagesMatchApprove
} from '../apis/imageV2APIs';

interface imageState {
	error: any;
	loading: boolean;
	priceList: Array<any>;
	newImagesList: Array<any>;
	selectedImagesList: Array<any>;
	currentPage: number;
	count: number;
	imageMatchCount: number;
	customerDetails: any;
	deviceList: any;
	imageMatchList: any;
}

const initialState: imageState = {
	loading: true,
	error: '',
	priceList: [],
	selectedImagesList: [],
	newImagesList: [],
	currentPage: 1,
	count: 0,
	imageMatchCount: 0,
	customerDetails: {},
	deviceList: [],
	imageMatchList: []
};

const newimagesSlice = createSlice({
	name: 'imagesSlice',
	initialState,
	reducers: {
		handlePaginationInImages(state, action: any) {
			state.currentPage = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder.addCase(getNewImagesList.pending, (state: imageState) => {
			state.loading = true;
			state.error = '';
			state.customerDetails = {};
		});
		builder.addCase(
			getNewImagesList.fulfilled,
			(state: imageState, action: any) => {
				state.loading = false;
				state.newImagesList = action?.payload?.data?.list;
				state.count = action?.payload?.data?.count;
				state.deviceList = [];
				state.error = '';
			}
		);
		builder.addCase(getNewImagesList.rejected, (state: imageState) => {
			state.loading = false;
		});
		builder.addCase(deleteNewImageList.pending, (state: imageState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			deleteNewImageList.fulfilled,
			(state: imageState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action?.payload?.message) });
			}
		);
		builder.addCase(deleteNewImageList.rejected, (state: imageState) => {
			state.loading = false;
		});
		builder.addCase(getImagesMatch.pending, (state: imageState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			getImagesMatch.fulfilled,
			(state: imageState, action: any) => {
				state.loading = false;
				state.imageMatchList = action?.payload?.data?.list;
				state.error = '';
				state.imageMatchCount = action?.payload?.data?.count;
			}
		);
		builder.addCase(getImagesMatch.rejected, (state: imageState) => {
			state.loading = false;
		});
		builder.addCase(imagesMatchApprove.pending, (state: imageState) => {
			state.loading = true;
		});
		builder.addCase(imagesMatchApprove.rejected, (state: imageState) => {
			state.loading = false;
		});
		builder.addCase(imagesMatchApprove.fulfilled, (state: imageState) => {
			state.loading = false;
		});
	}
});

export const { handlePaginationInImages } = newimagesSlice.actions;
export default newimagesSlice.reducer;
